import React from "react";
import { getCharges } from "../../../../../../../../../../hooks/useCharges";
import useDebugInformation from "../../../../../../../../../../hooks/useDebugInformation";
import { state, ui } from "../../../../../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";
import { JobType } from "@utils/BasicTypes";
import ComboDropDown from "../../../../../../../../../Shared/ComboDropDown";
import { handleJobChange, jobGetOptionLabel, jobIsOptionEqualToValue } from "./helpers";

const name = "JobDropDown"

type Props = {
    parent: string
    inputRef: any;
}
const assignCharges = async (problemComboJob: JobType) => {
    const postcode = ui.PropertyAddressPostcode;
    const accountCode = state.Account;
    const isCommercial = ui.PropertyAddressIsBusiness;
    const appointmentDate = ui.AppointmentDate;
    if (problemComboJob?.jobTypeCode && accountCode?.accountCode && postcode && appointmentDate) {
        let dateTimeRequired = new Date(appointmentDate as Date);
        // if dateTimeRequired is not of type Date convert to date
        if (!(dateTimeRequired instanceof Date)) {
            dateTimeRequired = new Date(dateTimeRequired);
        }
        await getCharges(
            accountCode.accountCode,
            postcode,
            problemComboJob.jobTypeCode,
            dateTimeRequired,
            isCommercial,
        );
    } else {
        ui.RateText = "";
    }
};

const JobDropDown: React.FC<Props> = ({ parent, inputRef }) => {
    const problemComboJob = useAppSelector(({ ui }) => ui.ProblemComboJob)
    const problemJobs = useAppSelector(({ ui }) => ui.ProblemJobs)

    const debugName = `${parent}▷[${name}]`

    React.useEffect(() => {
        if (problemComboJob?.jobTypeCode) {
            assignCharges(problemComboJob);
        }
    }, [problemComboJob])

    useDebugInformation(debugName, { problemComboJob, problemJobs })
    return (
        < ComboDropDown
            sm={12}
            name="Job"
            options={React.useMemo(() => problemJobs && problemJobs.length > 0 ? problemJobs : [], [problemJobs])}
            onChange={(e: React.SyntheticEvent<Element, Event>, v: JobType) => handleJobChange(e, v, inputRef)}
            getOptionLabel={jobGetOptionLabel}
            isOptionEqualToValue={jobIsOptionEqualToValue}
            value={problemComboJob}
        />
    )
}

export default React.memo(JobDropDown)